import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { TreeNodeService } from 'src/app/shared/services/treedata.service';
import { GlobalConstants } from '../../common/global-variable';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { NgxIndexedDBService } from 'ngx-indexed-db';

@Component({
  selector: 'app-selection',
  templateUrl: './selection.component.html',
  styleUrls: ['./selection.component.scss']
})
export class SelectionComponent implements OnInit {

  totalCols = 11
  selectionCols = 8
  selectionRows = 9
  helpCols = 3
  helpRows = 9

  singles: any = [];
  filtered_singles: any = [];
  couples: any = [];
  filtered_couples: any = [];
  nodeinfos = {};
  coupleinfos = {};

  selectedValue: any;
  type = 'single';

  direction = '5'
  papertype = "A0"
  setting = "recommended"
  maxgeneration

  treeType = '1'
  gedcom
  gedcomfiles
  selectFormControl = new UntypedFormControl('', Validators.required);

  constructor(
    private ApiService: ApiService,
    private router: Router,
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    private treeService: TreeNodeService,
    private dbService: NgxIndexedDBService
  ) { }

  ngOnInit(): void {
    localStorage.removeItem('background')
    localStorage.removeItem('doc_id')
    localStorage.removeItem('papertype')
    localStorage.removeItem('recommended')
    localStorage.removeItem('manColor')
    localStorage.removeItem('womanColor')
    localStorage.removeItem('maleNodeColor')
    localStorage.removeItem('femaleNodeColor')
    localStorage.removeItem('borderColor')
    localStorage.removeItem('borderWidth');
    localStorage.removeItem('backOpacity')
    localStorage.removeItem('nodeOpacity')
    localStorage.removeItem('maxGeneration')
    localStorage.removeItem('cornerRound')
    localStorage.removeItem('global_padding')

    localStorage.removeItem('tree_width')
    localStorage.removeItem('tree_height')

    localStorage.removeItem('empty_node_setting');
    localStorage.removeItem('text_align');
    localStorage.removeItem('name_text_align');
    localStorage.removeItem('birth_setting');
    localStorage.removeItem('marriage_setting');
    localStorage.removeItem('death_setting');
    localStorage.removeItem('partner_setting');
    localStorage.removeItem('children_setting');
    localStorage.removeItem('flag_setting');
    localStorage.removeItem('profile_setting');
    localStorage.removeItem('warning_setting');

    if (window.innerWidth <= 768) {
      this.totalCols = 11
      this.selectionCols = 11
      this.selectionRows = 16
      this.helpCols = 11
      this.helpRows = 9
    }

    this.gedcomfiles = [];

    this.ApiService.getGedcoms().then((gedcoms: any) => {
      gedcoms.forEach(gedcom => {
        this.gedcomfiles.push({ id: gedcom._id, filename: gedcom.filename.split('-')[1] })
      });

    })

    this.gedcom = this.gedcomfiles[0]
  }

  goToWizard(){
    this.router.navigateByUrl('/wizard');
  }

  onResize(event) {
    if (event.target.innerWidth > 768) {
      this.totalCols = 11
      this.selectionCols = 8
      this.selectionRows = 9
      this.helpCols = 3
      this.helpRows = 9
    }
    else if (event.target.innerWidth <= 768) {
      this.totalCols = 11
      this.selectionCols = 11
      this.selectionRows = 16
      this.helpCols = 11
      this.helpRows = 9
    }
  }

  generateTree() {
    localStorage.setItem("type", this.type);
    localStorage.setItem("id", this.selectedValue);
    localStorage.setItem("papertype", this.papertype);
    localStorage.setItem("direction", this.direction);
    localStorage.setItem("setting", this.setting);

    if (this.setting == "recommended") {
      localStorage.setItem('manColor', '#000')
      localStorage.setItem('womanColor', '#000')
      localStorage.setItem('maleNodeColor', '#fff')
      localStorage.setItem('femaleNodeColor', '#fff')
      localStorage.setItem('borderColor', '#000')
      localStorage.setItem('borderWidth', '2');
      localStorage.setItem('backOpacity', '1')
      localStorage.setItem('nodeOpacity', '1')
      localStorage.setItem('maxGeneration', '10')
      localStorage.setItem('cornerRound', '50')
      localStorage.setItem('global_padding', '5')
      localStorage.setItem('empty_node_setting', 'none');
      localStorage.setItem('text_align', 'middle');
      localStorage.setItem('name_text_align', 'middle');
      localStorage.setItem('birth_setting', 'block');
      localStorage.setItem('marriage_setting', 'block');
      localStorage.setItem('death_setting', 'block');
      localStorage.setItem('partner_setting', 'SHOW');
      localStorage.setItem('children_setting', 'SHOW');
      localStorage.setItem('flag_setting', 'HIDE');
      localStorage.setItem('profile_setting', 'SHOW');
      localStorage.setItem('warning_setting', 'HIDE');
    } else if (this.setting == "all") {
      localStorage.setItem('manColor', '#000')
      localStorage.setItem('womanColor', '#000')
      localStorage.setItem('maleNodeColor', '#fff')
      localStorage.setItem('femaleNodeColor', '#fff')
      localStorage.setItem('borderColor', '000')
      localStorage.setItem('borderWidth', '2');
      localStorage.setItem('backOpacity', '1')
      localStorage.setItem('nodeOpacity', '1')
      localStorage.setItem('maxGeneration', '10')
      localStorage.setItem('cornerRound', '50')
      localStorage.setItem('global_padding', '5')
      localStorage.setItem('empty_node_setting', 'block');
      localStorage.setItem('text_align', 'middle');
      localStorage.setItem('name_text_align', 'middle');
      localStorage.setItem('birth_setting', 'block');
      localStorage.setItem('marriage_setting', 'block');
      localStorage.setItem('death_setting', 'block');
      localStorage.setItem('partner_setting', 'SHOW');
      localStorage.setItem('children_setting', 'SHOW');
      localStorage.setItem('flag_setting', 'SHOW');
      localStorage.setItem('profile_setting', 'SHOW');
      localStorage.setItem('warning_setting', 'SHOW');
    }

    let width, height;

    switch (this.papertype) {
      case 'A0':
        width = '67408';
        height = '47679';
        this.maxgeneration = this.type == 'single' ? 10 : 9
        break;
      case 'A1':
        width = '47679';
        height = '33676';
        this.maxgeneration = this.type == 'single' ? 8 : 7
        break;
      case 'A2':
        width = '33676';
        height = '23811';
        this.maxgeneration = this.type == 'single' ? 7 : 6
        break;
      case 'A3':
        width = '23811';
        height = '16838';
        this.maxgeneration = this.type == 'single' ? 6 : 5
        break;
      case 'A4':
        width = '16838';
        height = '11906';
        this.maxgeneration = this.type == 'single' ? 5 : 4
        break;

      default:
        this.maxgeneration = 10
        break;
    }

    localStorage.setItem("maxGeneration", this.maxgeneration);
    localStorage.setItem("tree_width", width);
    localStorage.setItem("tree_height", height);



    if (this.selectedValue) {
      // Try to pass nodes info and coupleinfos to component.
      this.router.navigateByUrl('/dashboard/main');
    } else {
      this.selectFormControl.markAsTouched();
    }
  }

  onKeySingle(value) {
    this.filtered_singles = this.searchSingle(value);
  }

  onKeyCouple(value) {
    this.filtered_couples = this.searchCouple(value);
  }

  searchSingle(value: string) {
    let filter = value.toLowerCase();
    return this.singles.filter(option => ((option['firstName'] ?? "") + (option['lastName'] ?? "")).toLowerCase().includes(filter));
  }

  searchCouple(value: string) {
    let filter = value.toLowerCase();
    return this.couples.filter(couple => {
      let string = (couple.husb ? ((this.nodeinfos[couple.husb].firstName ?? "") + (this.nodeinfos[couple.husb].lastName ?? "")) : "") + (couple.wife ? ((this.nodeinfos[couple.wife].firstName ?? "") + (this.nodeinfos[couple.wife].lastName ?? "")) : "")

      return string.toLowerCase().includes(filter)
    })
  }


  gedcomChanged(event) {

    localStorage.setItem('gedcom_id', event.value.id);
    localStorage.setItem('gedcom_name', event.value.filename);
    this.ApiService.getGedcom(event.value.id).then((gedcom: any) => {

      this.singles = gedcom.indis;

      for (let index = 0; index < this.singles.length; index++) {
        const element = this.singles[index];

      }
      this.couples = gedcom.fams;
      this.couples.forEach(data => {
        this.coupleinfos[data.id] = data;
      });
      this.singles.forEach(data => {
        this.nodeinfos[data.id] = data;
        this.nodeinfos[data.id]['country'] = ""
        this.nodeinfos[data.id]['avatar_type'] = "sample"
        this.nodeinfos[data.id]['c_flag'] = ""
        this.nodeinfos[data.id]['father'] = (data['famc'] && this.coupleinfos[data['famc']]['husb']) ? this.coupleinfos[data['famc']]['husb'] : "";
        this.nodeinfos[data.id]['mother'] = (data['famc'] && this.coupleinfos[data['famc']]['wife']) ? this.coupleinfos[data['famc']]['wife'] : "";
        this.nodeinfos[data.id]['marriage'] = [];
        this.nodeinfos[data.id]['wife'] = [];
        this.nodeinfos[data.id]['husb'] = [];
        this.nodeinfos[data.id]['child_info'] = [];
        this.nodeinfos[data.id]['avatar_setting'] = 'SHOW';
        this.nodeinfos[data.id]['note'] = '';
        this.nodeinfos[data.id]['warning'] = false;

        if (data['fams']) {
          data['fams'].forEach(item => {
            this.nodeinfos[data.id]['marriage'] = { [item]: this.coupleinfos[item].marriage };

            if (data['sex'] == 'M') {
              if (this.coupleinfos[item].wife) this.nodeinfos[data.id]['wife'].push(this.coupleinfos[item].wife);
            }
            else {
              if (this.coupleinfos[item].husb) this.nodeinfos[data.id]['husb'].push(this.coupleinfos[item].husb);
            }
            this.coupleinfos[item].children.forEach(child => {
              this.nodeinfos[data.id]['child_info'].push(child);
            })
          })
        }
        else {
          this.nodeinfos[data.id]['wife'] = [];
          this.nodeinfos[data.id]['child_info'] = [];
        }
      });

      let temp1 = this.treeService.dateString(this.nodeinfos);

      this.filtered_singles = this.singles;
      this.filtered_couples = this.couples;

      // localStorage.setItem("nodeinfos", JSON.stringify(temp1))
      let nodeinfos = JSON.stringify(temp1)
      // localStorage.setItem("coupleinfos", JSON.stringify(this.coupleinfos))

      let coupleinfos = JSON.stringify(this.coupleinfos)
      // Delete store before insert
      this.dbService.deleteByKey('nodes', 1).subscribe((status) => {
        console.log('Deleted?:', status);
      }, err => console.log(err));
      // console.log(coupleinfos)
      this.dbService
        .add('nodes', {
          id: 1,
          nodeinfos: nodeinfos,
          coupleinfos: coupleinfos,
        })
        .subscribe((key) => {
          console.log('key: ', key);
        });
      this.dbService.getByKey('nodes', 1).subscribe((nodes:any) => {
        console.log(nodes);
        // let nodeinfos = JSON.parse(nodes.nodeinfos) 
        // console.log(nodeinfos)
      }, err => console.log(err));

    })
  }

}
